export default "__VITE_ASSET__zTFCsqd4__"